import type { SocialPlatform, SocialStandard } from "./social";
import { SOCIAL_PLATFORM, SOCIAL_STANDARD } from "./social";
import type { SocialRejectReason } from "./social-extraction";
import { SOCIAL_REJECT_REASON } from "./social-extraction";

export const SOCIAL_PLATFORM_LABELS: Record<SocialPlatform, string> = {
  [SOCIAL_PLATFORM.INSTAGRAM]: "Instagram",
  [SOCIAL_PLATFORM.TIKTOK]: "TikTok",
  [SOCIAL_PLATFORM.X]: "X",
};

export const SOCIAL_STANDARD_LABELS: Record<SocialStandard, string> = {
  [SOCIAL_STANDARD.MESSAGE_CLARITY]: "Message clarity",
  [SOCIAL_STANDARD.BRAND_VOICE]: "Brand voice",
  [SOCIAL_STANDARD.VISUAL_ACCESSIBILITY]: "Visual accessibility",
  [SOCIAL_STANDARD.DISCLOSURE]: "Disclosure",
  [SOCIAL_STANDARD.ACTIONABILITY]: "Actionability",
};

export const SOCIAL_REJECT_REASON_LABELS: Record<SocialRejectReason, string> = {
  [SOCIAL_REJECT_REASON.PARSE_FAILED]: "Unreadable provider row",
  [SOCIAL_REJECT_REASON.HANDLE_MISMATCH]: "Authored by another handle",
  [SOCIAL_REJECT_REASON.ACCOUNT_MISMATCH]: "Authored by another account",
  [SOCIAL_REJECT_REASON.TEXT_TOO_LONG]: "Caption over the configured limit",
  [SOCIAL_REJECT_REASON.MEDIA_DOWNLOAD_FAILED]: "Media could not be downloaded",
};
